<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand href="#">DocSigner</b-navbar-brand>
    </b-navbar>
    <b-container>
      <div style="padding-top: 10px">
        <b-form @submit.prevent="onSubmit">
          <b-form-group id="input-group-1" label="URL:" label-for="url">
            <b-form-input id="url" name="url" type="text" v-model="url" placeholder="Enter server URL"/>
          </b-form-group>
          <b-form-group id="input-group-2" label="User:" label-for="user">
            <b-form-input id="user" name="user" type="text" v-model="user" placeholder="Enter username"/>
          </b-form-group>
          <b-form-group id="input-group-3" label="Password:" label-for="password">
            <b-form-input id="password" name="password" type="password" v-model="password" placeholder="Enter password"/>
          </b-form-group>
          <b-alert v-if="error" variant="danger" show>{{ error }}</b-alert>
          <b-button block type="submit" variant="info">Login</b-button>
        </b-form>
      </div>
    </b-container>
  </div>
</template>

<script>
  import * as Sentry from '@sentry/browser';
  import okm from '../api';

  export default {
    name: 'Login',
    data() {
      return {
        url: localStorage.getItem('okm.doc-signer.url'),
        user: localStorage.getItem('okm.doc-signer.user'),
        password: null,
        error: null
      }
    },
    methods: {
      onSubmit() {
        if (this.url) {
          this.url = this.fixUrl(this.url);
          localStorage.setItem('okm.doc-signer.url', this.url);
          this.$store.commit('setUrl', this.url);

          if (this.user) {
            localStorage.setItem('okm.doc-signer.user', this.user);
            this.$store.commit('setUser', this.user);

            if (this.password) {
              okm.login(this.user, this.password).then(res => {
                this.$store.commit('setToken', res.data.Authorization);
                this.$router.replace('documents');
              }).catch(err => {
                if (err.response) {
                  if (err.response.status === 401) {
                    this.error = 'Unauthorized';
                  } else {
                    this.error = 'Unknown error';
                  }
                } else {
                  this.showError(err);
                }
              });
            } else {
              this.error = 'The password can\'t be empty';
            }
          } else {
            this.error = 'The username can\'t be empty';
          }
        } else {
          this.error = 'The URL field should be a valid URL';
        }
      },
      fixUrl(url) {
        let regex = /^(http|https)/;
        let fixed = url;

        if (fixed.length > 3 && !fixed.match(regex)) {
          fixed = 'https://' + fixed;
        }

        if (fixed.endsWith('/')) {
          fixed = fixed.substr(0, fixed.length - 1);
        }

        if (!fixed.endsWith('/openkm')) {
          fixed += '/openkm';
        }

        return fixed;
      },
      showError(err) {
        Sentry.captureException(err);
        this.error = err;
      }
    }
  }
</script>
